<template>
  <div class="container px-8 pt-16 mx-auto lg:px-16">
    <div class="flex flex-col md:flex-row">
      <img
        class="self-center object-contain md:p-8 mb-4 md:w-1/2 md:order-2"
        src="@/assets/img/quirby.jpg"
        alt
        srcset
      />
      <div class="flex flex-col justify-center md:w-1/2 md:order-1 md:ml-8">
        <h2
          id="fonctionnement"
          class="text-3xl font-bold tracking-wider uppercase font-raleway"
        >
          Vu à la télé
        </h2>
        <hr class="mb-10 border border-green-500" />
        <p class="mb-10">
          Nous sommes partenaires de “<span class="italic"
            >La&nbsp;Vie Secrète des&nbsp;Chats</span
          >” sur TF1 ! <br />HerdingCats a positionné le prototype sur la 3<sup>
            e
          </sup>
          saison de “<span class="italic"
            >La&nbsp;Vie Secrète des&nbsp;Chats</span
          >”une émission à succès sur TF1 qui est diffusée toutes les semaines à
          partir de mi-septembre 2019 jusqu'à fin décembre. <br />14 des chats
          suivis avec le dispositif HerdingCats sont commentés à l'écran&nbsp;!
        </p>
        <!-- <a href="#" v-scroll-to="'#footer'"
          class="block px-4 py-4 font-bold leading-none tracking-wider text-center text-white uppercase bg-green-500 rounded-full shadow-md hover:bg-green-400 hover:shadow-lg">
          Découvrir HerdingCats en avant-première
        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
